'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactNode } from 'react';
import { getQueryClient } from '@/app/_providers/get-query-client';
export function TanstackQueryProvider({
  children
}: {
  children: ReactNode;
}) {
  const queryClient = getQueryClient();
  return <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-component="TanstackQueryProvider" data-sentry-source-file="tanstackQuery-provider.tsx">
      {children}
      <ReactQueryDevtools initialIsOpen={false} data-sentry-element="ReactQueryDevtools" data-sentry-source-file="tanstackQuery-provider.tsx" />
    </QueryClientProvider>;
}